// Hooks
import React from 'react';

// Componentes de layout
import { Row, Table, Badge, Button } from 'reactstrap';

// Styles
import { FiEdit } from 'react-icons/fi';

const ListItemsTable = ({
  listItems,
  recordTypes,
  handleOpenModalToEditOption,
  removeListItem
}) => {
  if (listItems.length === 0) return null;

  return (
    <Row>
      <Table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Tipos de Registro</th>
            <th>Excluir</th>
          </tr>
        </thead>
        <tbody>
          {listItems.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>
                {item.recordTypeIds.map((id) => {
                  const rt = (recordTypes || []).find((rt) => rt.id === id);
                  return (
                    <h4 style={{ display: 'inline' }} key={id}>
                      <Badge color="secondary">{rt?.name || ''}</Badge>
                    </h4>
                  );
                })}
              </td>
              <td>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => handleOpenModalToEditOption(item)}
                >
                  <FiEdit size={14} />
                </Button>
                <Button
                  color="danger"
                  size="sm"
                  onClick={() => removeListItem(item)}
                >
                  <li className="fas fa-trash"></li>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Row>
  );
};

export default ListItemsTable;
